/*
 * @Author: Wei Guojun 
 * @Date: 2021-04-27 16:02:01 
 * @Last Modified by: Wei Guojun
 * @Last Modified time: 2022-05-12 15:40:50
 */

const CryptoJS = require('crypto-js');
class myLocalStorage {
    constructor() {
        this.autoEncrypt = true
        this.aseKey = '20210427'
    }

    setItem(key, value) {
        var v = value
        if (this.autoEncrypt) {
            v = this.AesEncrypt(v)
        }
        localStorage.setItem(key, v)
    }

    getItem(key) {
        let v = localStorage.getItem(key)
        if (v) {
            if (this.autoEncrypt) {
                return this.AesDecode(v)
            } else {
                return v
            }
        } else {
            return ''
        }
    }

    removeItem(key) {
        localStorage.removeItem(key)
    }

    /* 
        AES 加密
    */
    AesEncrypt(v) {
        return CryptoJS.AES.encrypt(v, CryptoJS.enc.Utf8.parse(this.aseKey), {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        }).toString()
    }

    //登录 加密
    encrypt(word) {
        var keyStr = 'lYAQcY@tQbfudxAV';    //判断是否存在ksy，不存在就用定义好的key
        var key = CryptoJS.enc.Utf8.parse(keyStr);
        var srcs = CryptoJS.enc.Utf8.parse(word);
        var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
        return encrypted.toString();
    }
    /* 
        AES 解密
    */
    AesDecode(v) {
        return CryptoJS.AES.decrypt(v, CryptoJS.enc.Utf8.parse(this.aseKey), {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        }).toString(CryptoJS.enc.Utf8)
    }


}
export default new myLocalStorage()


// import CryptoJS from 'crypto-js';
 
// export default {
//     //随机生成指定数量的16进制key
//     generatekey(num) {
//         let library = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
//         let key = "";
//         for (var i = 0; i < num; i++) {
//             let randomPoz = Math.floor(Math.random() * library.length);
//             key += library.substring(randomPoz, randomPoz + 1);
//         }
//         return key;
//     },
    
//     //加密
//     encrypt(word, keyStr) {
//         keyStr = keyStr ? keyStr : 'XXXXXXXXXXXXX'; //判断是否存在ksy，不存在就用定义好的key
//         var key = CryptoJS.enc.Utf8.parse(keyStr);
//         var srcs = CryptoJS.enc.Utf8.parse(word);
//         var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
//         return encrypted.toString();
//     },
//     //解密
//     decrypt(word, keyStr) {
//         keyStr = keyStr ? keyStr : 'XXXXXXXXXXXXX';
//         var key = CryptoJS.enc.Utf8.parse(keyStr);
//         var decrypt = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
//         return CryptoJS.enc.Utf8.stringify(decrypt).toString();
//     }
// }
